import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/components/Common";
import { Page, PageHeader, Loading, ErrorNote } from "@/components/Common";

export function HistoryPage() {
  const [eras, setEras] = useState(null);
  useEffect(() => {
    api.get("/eras").then((r) => setEras(r.data)).catch(() => setEras([]));
  }, []);

  return (
    <Page>
      <PageHeader title="تاریخِ ادب" subtitle="ابتدائی دور سے معاصر ادب تک — ادوار وار مطالعہ" crumbs={[{ label: "تاریخِ ادب" }]} />
      {!eras ? (
        <Loading />
      ) : (
        <div className="relative border-s-2 border-[#d4af37]/50 ms-3 space-y-8" data-testid="eras-timeline">
          {eras.map((e) => (
            <div key={e.slug} className="relative ps-8">
              <span className="absolute -start-[11px] top-3 w-5 h-5 rounded-full bg-[#f5efe3] border-2 border-[#c5a059]" />
              <Link
                to={`/history/${e.slug}`}
                data-testid={`era-card-${e.slug}`}
                className="block bg-[#fdfbf7] border border-[#d4af37]/40 rounded-xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(42,21,8,0.12)] hover:border-[#d4af37]"
              >
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h3 className="text-2xl font-bold text-[#2a1508] leading-[2]">{e.title}</h3>
                  <span className="font-ui text-sm text-[#c5a059]">{e.years}</span>
                </div>
                <p className="mt-2 text-base sm:text-lg text-[#5c3a21] leading-[2.2] line-clamp-2">{e.summary}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-[#2a1508] text-base">تفصیل پڑھیں <ArrowLeft size={15} /></span>
              </Link>
            </div>
          ))}
        </div>
      )}
    </Page>
  );
}

export function EraPage() {
  const { slug } = useParams();
  const [era, setEra] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setEra(null);
    setErr(false);
    api.get(`/eras/${slug}`).then((r) => setEra(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <Page><ErrorNote message="یہ دور نہیں ملا" /></Page>;
  if (!era) return <Page><Loading /></Page>;

  return (
    <Page>
      <PageHeader title={era.title} subtitle={era.years} crumbs={[{ label: "تاریخِ ادب", to: "/history" }, { label: era.title }]} />
      <div className="bg-[#fdfbf7] border border-[#d4af37]/40 rounded-2xl p-6 sm:p-10 shadow-[0_4px_20px_rgba(42,21,8,0.06)]" data-testid="era-content">
        <p className="text-lg leading-[2.3] text-[#33200f] text-right">{era.summary}</p>
      </div>
    </Page>
  );
}
